import { useEffect, useState } from "react";
import "./Loader.css";
import { getBrandingFromCache } from "../Context/BrandingContext";

const LoadingScreen = ({ isAppLoading = true, onFinish }) => {
  const [fadeOut, setFadeOut] = useState(false);
  const [showTagline, setShowTagline] = useState(false);
  const [showBar, setShowBar] = useState(false);
  const branding = getBrandingFromCache();

  useEffect(() => {
    const t1 = setTimeout(() => setShowTagline(true), 800);
    const t2 = setTimeout(() => setShowBar(true), 1400);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, []);

  useEffect(() => {
    if (!isAppLoading && showBar) {
      const t3 = setTimeout(() => setFadeOut(true), 400);
      const t4 = setTimeout(() => onFinish?.(), 1000);
      return () => {
        clearTimeout(t3);
        clearTimeout(t4);
      };
    }
  }, [isAppLoading, showBar, onFinish]);

  return (
    <div className={`loader-screen ${fadeOut ? "loader-fade-out" : ""}`}>
      {/* Floating gold particles */}
      <div className="loader-particles">
        {[...Array(24)].map((_, i) => (
          <span key={i} className="loader-particle" />
        ))}
      </div>

      {/* Corner accents */}
      <div className="loader-corner loader-corner-tl" />
      <div className="loader-corner loader-corner-br" />

      {/* Center content */}
      <div className="loader-center">
        <div className="loader-logo-wrap">
          <img src={branding.logo} alt={branding.name} className="loader-logo" />
        </div>

        <div className="loader-gold-divider" />

        <div className={`loader-tagline ${showTagline ? "loader-tagline-visible" : ""}`}>
          Crafted With Passion, Worn With Pride
        </div>

        <div className={`loader-progress-track ${showBar ? "loader-progress-visible" : ""}`}>
          <div className={`loader-progress-bar ${showBar ? "loader-progress-animate" : ""}`} />
        </div>
      </div>

      {/* Bottom text */}
      <div className={`loader-bottom ${showTagline ? "loader-bottom-visible" : ""}`}>
        <span>Luxury Jewellery &nbsp;&bull;&nbsp; Certified Diamonds &nbsp;&bull;&nbsp; Trusted Craft</span>
      </div>
    </div>
  );
};

export default LoadingScreen;
